module.exports = __webpack_public_path__ + "img/franchising_help_marketing1.9cf81162.png";